import React from "react";
import styles from "./contact.css";
import FontAwesome from "react-fontawesome";
import { FormattedMessage } from "react-intl";
import { ContactConfig } from "./ContactConfig";

export const Contact = () => {
  return (
    <div className={styles.container} id="contact">
      <h2 className={styles.headerTitle}>
        <FormattedMessage
          id="Contact.headerTitle"
          defaultMessage="Contact Us"
        />
      </h2>
      {renderContactItems()}
      <div className={styles.socialNetworks}>{renderSocialMedia()}</div>
    </div>
  );
};

const renderContactItems = () => {
  return ContactConfig.contactItems.map((item, i) => {
    return (
      <p key={i}>
        <FontAwesome name={item.icon} className={styles.iconItem} />
        {item.text}
      </p>
    );
  });
};

const renderSocialMedia = () => {
  return ContactConfig.socialMedia.map((item, i) => {
    return (
      <a href={item.url} target="_blank" rel="noopener noreferrer" key={i}>
        <FontAwesome name={item.id} className={styles.socialNetworksItem} />
      </a>
    );
  });
};

export default Contact;



// WEBPACK FOOTER //
// ./src/containers/contact/Contact.js